<div class="container">
    <div class="info-box">
        <p class="info-text asterisk-text-before">
            Weitere 1GB SSD Plattenplat 1 Euro / Monat
        </p>
        <p class="info-text double-asterisk-text-before">
            Weiter 1 GB/Monat 1 Euro
        </p>
        <p class="info-text third-asterisk-text-before">
            Upload and Download Traffic, interner Netzwerkverkehr kostenlos
        </p>
    </div>

</div>